import React from "react";
import ChevronIcon from "../../../../Common/Svgs/ChevronIcon";

const TrikeSosCard = ({ title, badges = [], onClick }) => {
  return (
    <div
      className="rounded-md bg-[#FAFAFA] border border-light-grey flex items-center justify-between h-[70px] p-4 cursor-pointer"
      onClick={onClick}
    >
      <div className="flex gap-x-2.5 items-center">
        <p className="rounded-full w-[38px] h-[38px] bg-alert-10 text-alert-red flex justify-center items-center font-poppins font-medium text-[11px]">
          SOS
        </p>
        <p className="font-poppins font-medium text-base leading-none text-black">
          {title}
        </p>
      </div>
      <div className="flex gap-x-4 items-center">
        {badges.map((badge) => {
          const { text, type } = badge;
          let badgeClass =
            "rounded-md p-2 flex justify-center items-center font-poppins font-medium text-[11px]";

          if (type === "primary") {
            badgeClass += " bg-primary text-white";
          } else if (type === "warning") {
            badgeClass += " bg-warning-10 text-warning";
          } else {
            // default/success is light green / primary text
            badgeClass += " bg-green-10 text-primary";
          }

          return (
            <p key={`badge-${text}`} className={badgeClass}>
              {text}
            </p>
          );
        })}
        <ChevronIcon strokeWidth="1" className="w-5 h-5 stroke-dark-gray" />
      </div>
    </div>
  );
};

export default TrikeSosCard;
